import { render, staticRenderFns } from "./Line_editor.vue?vue&type=template&id=2f0f87ba&scoped=true"
import script from "./Line_editor.vue?vue&type=script&lang=js"
export * from "./Line_editor.vue?vue&type=script&lang=js"
import style0 from "./Line_editor.vue?vue&type=style&index=0&id=2f0f87ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f0f87ba",
  null
  
)

export default component.exports